import axios from "axios";

// Helper to read cookie by name
function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Configure axios defaults for CSRF
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.withCredentials = true;

// Add CSRF token to every request automatically
axios.interceptors.request.use((config) => {
  const headers = { ...config.headers };
  const csrftoken = getCookie("csrftoken");
  if (csrftoken) {
    headers["X-CSRFToken"] = csrftoken;
  }

  // Add admin auth token if available
  const token = localStorage.getItem("admin-token");
  if (token && !headers.Authorization) {
    headers.Authorization = `Token ${token}`;
  }

  return { ...config, headers };
});

// Global response error interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        // Token expired or invalid - clear and redirect
        localStorage.removeItem("admin-token");
        localStorage.removeItem("admin-expirationDate");
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
